<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">图示</el-radio>
        <el-radio v-model="radio" :label="2">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="clickBtn()">查询</el-button>
        </div>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="event">
            <div class="event-icon hight-color">
              <svg name="systemValidation" class="icon-svg"></svg>
            </div>
            <div class="event-title">
              <div class="value hight-color">{{highEventNum}}</div>
              <div class="unit">起</div>
            </div>
            <div class="title-triangle-shadow"></div>
            <div class="event-context-shadow"></div>
            <div class="title-triangle hight-border-color"></div>
            <div class="event-context hight-bg-color">
              高危事件
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="event">
            <div class="event-icon medium-color">
              <svg name="systemValidation" class="icon-svg"></svg>
            </div>
            <div class="event-title">
              <div class="value medium-color">{{mediumEventNum}}</div>
              <div class="unit">起</div>
            </div>
            <div class="title-triangle-shadow"></div>
            <div class="event-context-shadow"></div>
            <div class="title-triangle medium-border-color"></div>
            <div class="event-context medium-bg-color">
              中危事件
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="event">
            <div class="event-icon low-color">
              <svg name="systemValidation" class="icon-svg"></svg>
            </div>
            <div class="event-title">
              <div class="value low-color">{{lowEventNum}}</div>
              <div class="unit">起</div>
            </div>
            <div class="title-triangle-shadow"></div>
            <div class="event-context-shadow"></div>
            <div class="title-triangle low-border-color"></div>
            <div class="event-context low-bg-color">
              低危事件
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-show="radio === 2" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="clickBtn()">查询</el-button>
        </div>
      </div>
      <el-table :data="dataList" border style="width: 100%;">
        <el-table-column type="index" align="center" width="50"></el-table-column>
        <el-table-column prop="attacker" header-align="center" align="center" label="攻击者" width="180">
        </el-table-column>
        <el-table-column prop="destPort" header-align="center" align="center" label="目的端口" width="180">
        </el-table-column>
        <el-table-column prop="destPort_count" header-align="center" align="center" label="事件名称" width="180">
        </el-table-column>
        <el-table-column prop="destSecurityZone" header-align="center" align="center" label="目的安全域" width="180">
        </el-table-column>
        <el-table-column prop="srcGeoCountry" header-align="center" align="center" label="来源国家">
        </el-table-column>
        <el-table-column prop="srcGeoRegion" header-align="center" align="center" label="来源区域">
        </el-table-column>
        <el-table-column prop="firstOccurrenceTime" header-align="center" align="center" label="第一次发生时间">
        </el-table-column>

        <el-table-column prop="lastOccurrenceTime" header-align="center" align="center" label="最近发生时间">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'modularChild4',
  props: ['socUserName'],    
  data () {
    return {
      value1: '',
      value2: [],
      radio: 1,
      dataList: [],
      chartLoading: false,
      // highEventNum: Math.floor(Math.random() * (10 - 1)) + 1,
      // mediumEventNum: Math.floor(Math.random() * (10 - 1)) + 1,
      // lowEventNum: Math.floor(Math.random() * (10 - 1)) + 1,
      highEventNum: 0,
      mediumEventNum: 0,
      lowEventNum: 0,      
      endTime: "",
      username: "",
      startTime: ""        
    }
  },
  methods: {
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      let params = {
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }     
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/querySecurityIncidentClassificationStatistics`, params)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterData(data.data.data.records)
            // this.chartsi.setOption(this.optioni)
            this.dataList = data.data.data.records
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    formatterData(data) {
      let highEventNum = 0
      let mediumEventNum = 0
      let lowEventNum = 0
      data.forEach(item => {
        if (item.threatSeverity === '高') {
          highEventNum++
        } else if (item.threatSeverity === '中') {
          mediumEventNum++
        } else if (item.threatSeverity === '低') {
          lowEventNum++
        }
      })
      this.highEventNum = highEventNum
      this.mediumEventNum = mediumEventNum
      this.lowEventNum = lowEventNum      
      return []
    }
  },
  mounted () {
    this.getTime();
  }
}
</script>

<style lang="scss" scoped>
$event-bg-color: #ffefe4;
$high-color: #fe6363;
$medium-color: #f9a063;
$low-color: #f8d04f;
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 200px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
  .event {
    position: relative;
    width: 200px;
    height: 300px;
    margin: 10vh auto;
    background: $event-bg-color;
    .title-triangle {
      transform: scale(1.1);
      // transform: scaleX(1.1);   /* X轴方向放大/缩小 */
      // transform: scaleY(1.1);
      // transform: scaleZ(0.5);
      position: absolute;
      // left: -4px;
      bottom: 100px;
      border-top: 50px solid rgba(0, 0, 0, 0);
      border-left: 100px solid rgba(0, 0, 0, 0);
      border-right: 100px solid #fff;
      border-bottom: 50px solid #fff;
    }
    .title-triangle-shadow {
      // transform: scaleX(1.1);
      position: absolute;
      bottom: 104px;
      border-top: 50px solid rgba($color: #000000, $alpha: 0);
      border-left: 100px solid rgba($color: #000000, $alpha: 0);
      border-right: 100px solid #003;
      border-bottom: 50px solid #003;
    }
     .event-context-shadow {
      // transform: scaleX(1.1);
      position: absolute;
      bottom: 0;
      height: 104px;
      width: 100%;
      background: #003;
    }
    .event-icon {
      font-size: 20px;
      position: absolute;
      top: 20px;
      left: 20px;
      // width: 100%;
      // height: 20%;
    }
    .event-title {
      padding-top: 60px;
      width: 100%;
      height: 40%;
      text-align: center;
      .value {
        font-weight: bold;
        font-size: 40px;
        display: inline-block;
      }
      .unit {
        font-size: 18px;
        display: inline-block;
      }
    }
    .event-context {
      transform: scaleX(1.1);
      position: absolute;
      bottom: 0;
      left: 0;
      height: 95px;
      width: 100%;
      text-align: center;
      line-height: 40px;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
    }
  }
}
.hight-bg-color {
  background: $high-color;
}
.medium-bg-color {
  background: $medium-color;
}
.low-bg-color {
  background: $low-color;
}
.hight-color {
  color: $high-color;
}
.medium-color {
  color: $medium-color;
}
.low-color {
  color: $low-color;
}
.hight-border-color {
  border-right-color: $high-color!important;
  border-bottom-color: $high-color!important;
}
.medium-border-color {
  border-right-color: $medium-color!important;
  border-bottom-color: $medium-color!important;
}
.low-border-color {
  border-right-color: $low-color!important;
  border-bottom-color: $low-color!important;
}
</style>